export function getCsrfFromCookie(): string | null {
    const name = "csrf_token=";
    const cookies = decodeURIComponent(document.cookie).split(";");
  
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name)) {
        return cookie.substring(name.length);
      }
    }
  
    return null;
  }
  